// Device context — computes the live device snapshot once at the app root and
// serves it to every consumer, so the resize/orientation listeners run a single
// time rather than per component.

import { createContext, useContext, type ReactNode } from "react";

import { useDeviceInfo, type DeviceInfo, type DeviceMode } from "./useDeviceInfo";

const DeviceContext = createContext<DeviceInfo | null>(null);

export function DeviceProvider({ children }: { children: ReactNode }) {
  const info = useDeviceInfo();
  return <DeviceContext.Provider value={info}>{children}</DeviceContext.Provider>;
}

/** Full device snapshot. Throws if used outside <DeviceProvider>. */
export function useDevice(): DeviceInfo {
  const ctx = useContext(DeviceContext);
  if (!ctx) throw new Error("useDevice must be used within <DeviceProvider>");
  return ctx;
}

/** Just the layout switch — the common case in views. */
export function useDeviceMode(): DeviceMode {
  return useDevice().mode;
}
